import React from 'react';
import {IWidgetResponse as IOddsComparisonWidgetResponse} from '../api/odds-comparison';
import {IWidgetResponse} from '../api/match-center'; // Rename to IMatchCenterWidgetResponse
import {IEvent, IProviderCompetition} from "../utils/types";

interface IGlobalState {
  widget: IWidgetResponse | null;
  oddsComparisonWidget: IOddsComparisonWidgetResponse | null;
  languageId: number | null;
  promotedProvider: IProviderCompetition | null;
  event: IEvent | null;
  hasCache: boolean;
}

const defaultGlobalState: IGlobalState = {
  widget: null,
  oddsComparisonWidget: null,
  languageId: null,
  promotedProvider: null,
  event: null,
  hasCache: false
}

type Action =
  | { type: 'setWidget'; payload: IWidgetResponse }
  | { type: 'setOddsComparisonWidget'; payload: IOddsComparisonWidgetResponse }
  | { type: 'setLanguageId'; payload: number }
  | { type: 'setPromotedProvider'; payload: IProviderCompetition }
  | { type: 'setEvent'; payload: IEvent }
  | { type: 'setIfHasCache'; payload: boolean }

const reducer = (state: IGlobalState, action: Action): IGlobalState => {
  switch (action.type) {
    case 'setWidget':
      return {
        ...state,
        widget: action.payload,
        languageId: action.payload.languageId
      }
    case 'setOddsComparisonWidget':
      return {
        ...state,
        oddsComparisonWidget: action.payload,
        languageId: action.payload.languageId
      }
    case 'setLanguageId':
      return {
        ...state,
        languageId: action.payload
      }
    case 'setPromotedProvider':
      return {
        ...state,
        promotedProvider: action.payload
      }
    case 'setEvent':
      return {
        ...state,
        event: action.payload,
      }
    case 'setIfHasCache':
      return {
        ...state,
        hasCache: action.payload,
      }

    default:
      return state
  }
}

const defaultDispatch: React.Dispatch<Action> = () => defaultGlobalState //the default will never be used

const GlobalState = React.createContext({
  globalState: defaultGlobalState,
  globalStateDispatch: defaultDispatch
});

export const useGlobalState = () => React.useContext(GlobalState)

const GlobalStateProvider = (props: React.PropsWithChildren<{}>) => {
  const [globalState, globalStateDispatch] = React.useReducer(reducer, defaultGlobalState)

  return (
    <GlobalState.Provider value={{globalState, globalStateDispatch}}>
      {props.children}
    </GlobalState.Provider>
  )
}

export default GlobalStateProvider


